// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonGroupRoot_pWLO6 {\n  display: flex;\n  gap: 4px;\n}", "",{"version":3,"sources":["webpack://./components/CollectionsPanel/components/NavigationDialog/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,QAAA;AACJ","sourcesContent":[".buttonGroupRoot {\r\n    display: flex;\r\n    gap: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonGroupRoot": "buttonGroupRoot_pWLO6"
};
export default ___CSS_LOADER_EXPORT___;
